import DeviceFragment from 'components/core/DeviceFragment';
import FadingDivider from 'components/core/FadingDivider';
import { ReactNode } from 'react';
import { VStack } from 'reaction';
import './GitHubAchievment.css';

export interface GitHubAchievmentProps {
    name: string;
    description: string;
    badge: string;
    children: ReactNode;
}

export default function GitHubAchievment({
    name,
    description,
    badge,
    children,
}: GitHubAchievmentProps) {
    function BadgeDetails() {
        return (
            <>
                <img src={badge} alt={`${name} Achievement Badge`} className='badge' />
                <h3>{name}</h3>
                <p className='github-description'>{description}</p>
                <FadingDivider />
                <p className='custom-description'>{children}</p>
            </>
        );
    }

    return (
        <>
            <DeviceFragment type={['desktop', null]}>
                <VStack className='github-achievment' justify='start'>
                    <BadgeDetails />
                </VStack>
            </DeviceFragment>

            <DeviceFragment type={[null, 'tablet']}>
                <VStack className='github-achievment mobile' justify='start'>
                    <BadgeDetails />
                </VStack>
            </DeviceFragment>
        </>
    );
}
